module.exports = __webpack_public_path__ + "img/arrow-down-icon.8231861f.svg";